module.exports = __webpack_public_path__ + "static/media/tyler-menezes.665983d4.png";